import { observeElementRect } from '@tanstack/react-virtual';

// TanStack Virtual sizes its window from the scroll element's box. While a
// tab holding the table is hidden (`display: none`; the persistent Watchlist
// tab), and in layout-less test DOMs, that box is 0x0: keep the initial rect
// instead so the first screen of rows is already rendered when the tab is
// shown. Its ResizeObserver reports the real box on the way back; a browser
// may reset the offset of a scroller it stopped rendering without a `scroll`
// event, so resync the virtualizer's offset then. Used by DataTable and the
// Watchlist grid as their virtualizer's `observeElementRect`.
export function observeScrollElementRect(instance, onRect) {
    let hidden = false;
    return observeElementRect(instance, (rect) => {
        if (rect.width === 0 && rect.height === 0) {
            hidden = true;
            onRect(instance.options.initialRect);
            return;
        }
        onRect(rect);
        if (!hidden) return;
        hidden = false;
        const element = instance.scrollElement;
        if (element && element.scrollTop !== instance.scrollOffset) {
            element.dispatchEvent(new Event('scroll'));
        }
    });
}
